import styled, { css } from "styled-components";
import { Radio as RadioAntd } from "antd";
import color from "../_style/color";

const themeOption = {
  grey: css`
    .ant-radio-button-wrapper:first-child {
      border-color: ${color.gainsboro};
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled),
    .ant-radio-button-wrapper-checked:not([class*=" ant-radio-button-wrapper-disabled"]).ant-radio-button-wrapper:first-child {
      font-weight: bold;
      border-color: ${color.gainsboro};
      background: ${color.component};
    }

    .ant-radio-button-wrapper:hover {
      background: ${color.component};
    }
  `,
  "solid-primary": css`
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled),
    .ant-radio-button-wrapper-checked:not([class*=" ant-radio-button-wrapper-disabled"]).ant-radio-button-wrapper:first-child {
      color: unset;
      border-color: ${color.gainsboro};
      background: ${color.clearDay};
    }
  `,
  primary: css`
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled),
    .ant-radio-button-wrapper-checked:not([class*=" ant-radio-button-wrapper-disabled"]).ant-radio-button-wrapper:first-child {
      color: ${color.primary};
      border-color: ${color.gainsboro};
    }

    .ant-radio-button-wrapper:hover {
      color: unset;
    }
  `,
};

const Radio = styled(RadioAntd)``;
Radio.Group = styled(Radio.Group).attrs((props) => ({ type: props.type }))`
  ${({ type }) => themeOption[type]}

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    content: none;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
    box-shadow: unset;
  }

  .ant-radio-button-wrapper {
    border-left-width: 1px;
  }
`;
Radio.Button = styled(Radio.Button)`
  height: auto;
  padding: unset;
  line-height: unset;
`;

export default Radio;
